/**
 * Refresh if our app version has changed
 */
const getVersionFromHtml = function(html) {
  try {
    const meta = html.querySelector('meta[name="X-App-Version"]');
    return meta.getAttribute('content');
  } catch(e) {
    console.log('app:getVersionFromHtml', e.message);
    return '0.0.0:0';
  }
};

const currentVersion = getVersionFromHtml(document);
console.log('app:currentVersion', currentVersion);

// reload if new build version detected
up.on('up:fragment:loaded', (event) => {
  try {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(event.response.text, 'text/html');
    const responseVersion = getVersionFromHtml(parsedHtml);
    console.log('app:responseVersion', responseVersion);
    if(responseVersion !== currentVersion) {
      throw new Error('New version detected: ' + responseVersion + ' !== ' + currentVersion);
    }
  } catch(e) {
    console.log('app:versionMismatch', e.message);
    up.cache.expire();
    event.preventDefault();
    return event.request.loadPage();
  }
});

/**
* Videos break in Safari when they are injected into the DOM.
* - Only binds event if Safari browser
* - `initialLoad` flag avoids our code running on initial page render
* - Query for all video elements inside fragment
* - Overwriting its `outerHTML` forces Safari to re-render the video.
*/
const isSafari = () => {
  const ua = navigator.userAgent;
  console.log(`User Agent: ${ua}`);
  return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('CriOS') && !ua.includes('FxiOS');
};

if (isSafari()) {
  let initialLoad = true;
  up.on('up:fragment:inserted', (event, fragment) => {
    if (initialLoad) {
      initialLoad = false;
      return;
    }

    const videos = fragment.querySelectorAll('video');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      video.outerHTML = video.outerHTML;
    });
  });
}

/**
 * support "inline" modals with `up-inlinemodal="targetSelector"`
 * https://groups.google.com/g/unpoly/c/8ysO_omY_-o/m/pefNf3Y-AgAJ
 *
 * Usage:
 *   <button data-up="false" up-inlinemodal="#searchDiv" up-inlinemodal-options='{ "flavor" : "search" }'>...</button>
 */
up.on('click', '[up-inlinemodal]', function(event, link) {
  const selector = link.getAttribute('up-inlinemodal');
  const fragment = up.fragment.get(selector);
  const options = JSON.parse(link.getAttribute('up-inlinemodal-options')) || {};

  up.layer.open({
    document: fragment.outerHTML,
    mode: "modal",
    target: selector,
    ...options,
  });

  event.preventDefault();
});

/**
 * Skip link support
 * Prevents adding a hash to the history
 * and focuses the target element.
 */
up.on('click', 'a[up-id="skip-link"]', function(event, link) {
  event.preventDefault(); // avoid adding hash to history

  const hash = link.getAttribute('href'); // e.g. "#main"
  const target = document.querySelector(hash);

  if (target) {
    target.setAttribute('tabindex', '-1'); // make focusable
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: 'instant' });
    target.removeAttribute('tabindex');
  }
});

// Ensure Google Maps are initialised on page/fragment load
up.compiler('.gm-map', function(element) {
  Alpine.store('gmaps').load().then(() => {
    if (window.googleMaps) {
      googleMaps.init();
    }
  });
});
